const jwt_customizer = {
    general: 'Ocurrió un error al personalizar el token JWT. Por favor, inténtalo de nuevo más tarde.',
    can_not_create_for_admin_tenant: 'No se puede crear un personalizador de token JWT para el inquilino de administrador.',
};
export default Object.freeze(jwt_customizer);
